import { ref, inject } from "vue";
import type { DetailsFormSchema } from "../schemas/detailsForm";
import { transformProfileToApi } from "../utils/transformers/profileTransformers";
import { useDirtyTracking } from "./useDirtyTracking";
import { ListingDetailsStoreKey } from "./listingStoreKeys";

export function createListingDetailsStore() {
    const { model, initial, isDirty, markSaved, resetAll } = useDirtyTracking<DetailsFormSchema | undefined>();
    const isValid = ref(false);
    const hasActiveProSubscription = ref(true);

    function getPublishable(slug: string) {
        return transformProfileToApi(model.value, slug, hasActiveProSubscription.value);
    }

    return {
        model,
        initial,
        isDirty,
        isValid,
        hasActiveProSubscription,
        markSaved,
        resetAll,
        getPublishable,
    };
}

export function useListingDetailsStore() {
    const store = inject(ListingDetailsStoreKey);
    if (!store) {
        throw new Error('useListingDetailsStore must be used within a component that provides ListingDetailsStoreKey');
    }
    return store;
}
